/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Export_File_TitleInputs */

const en_toolbar_secondary_export_file_title = /** @type {(inputs: Toolbar_Secondary_Export_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export File`)
};

const fr_toolbar_secondary_export_file_title = /** @type {(inputs: Toolbar_Secondary_Export_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter le Fichier`)
};

const de_toolbar_secondary_export_file_title = /** @type {(inputs: Toolbar_Secondary_Export_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportdatei`)
};

const it_toolbar_secondary_export_file_title = /** @type {(inputs: Toolbar_Secondary_Export_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta file`)
};

const ru_toolbar_secondary_export_file_title = /** @type {(inputs: Toolbar_Secondary_Export_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт файла`)
};

const es_toolbar_secondary_export_file_title = /** @type {(inputs: Toolbar_Secondary_Export_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar archivo`)
};

const zh_cn2_toolbar_secondary_export_file_title = /** @type {(inputs: Toolbar_Secondary_Export_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出文件`)
};

const ja_toolbar_secondary_export_file_title = /** @type {(inputs: Toolbar_Secondary_Export_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルのエクスポート`)
};

const hi_toolbar_secondary_export_file_title = /** @type {(inputs: Toolbar_Secondary_Export_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात फ़ाइल`)
};

const pt_pt2_toolbar_secondary_export_file_title = /** @type {(inputs: Toolbar_Secondary_Export_File_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de exportação`)
};

/**
* | output |
* | --- |
* | "Export File" |
*
* @param {Toolbar_Secondary_Export_File_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_export_file_title = /** @type {((inputs?: Toolbar_Secondary_Export_File_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Export_File_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toolbar_secondary_export_file_title(inputs)
	if (locale === "de") return de_toolbar_secondary_export_file_title(inputs)
	if (locale === "it") return it_toolbar_secondary_export_file_title(inputs)
	if (locale === "ru") return ru_toolbar_secondary_export_file_title(inputs)
	if (locale === "es") return es_toolbar_secondary_export_file_title(inputs)
	if (locale === "zh-CN") return zh_cn2_toolbar_secondary_export_file_title(inputs)
	if (locale === "ja") return ja_toolbar_secondary_export_file_title(inputs)
	if (locale === "hi") return hi_toolbar_secondary_export_file_title(inputs)
	if (locale === "pt-PT") return pt_pt2_toolbar_secondary_export_file_title(inputs)
	return en_toolbar_secondary_export_file_title(inputs)
});